import { render, staticRenderFns } from "./ForceActionButton.vue?vue&type=template&id=782c463c"
import script from "./ForceActionButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForceActionButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports